import React from 'react';
import { useIntl } from 'react-intl';

import { PostsTile } from '@components/molecules/PostsTile';

import { generatePath } from '@utils/core';

import { paths } from '@temp/paths';
import { commonMessages } from '@temp/intl';

import * as S from './styles';
import { IProps } from './types';

export const ProjectList: React.FC<IProps> = ({
  projects,
  onLoadMore,
  hasNextPage,
}) => {
  const intl = useIntl();
  return (
    <>
      <S.List className="project-list">
        {projects &&
          projects.map((item) => (
            <PostsTile
              key={item.id}
              link={generatePath(paths.inspirationsPost, { slug: item.name })}
              image={item.image}
              title={item.title}
              tags={[item.category]}
              square
            />
          ))}
      </S.List>
      <S.BorderDiv />
      {hasNextPage && (
        <S.ShowMoreButtonWrapper>
          <S.ShowMoreButton className="showmore" onClick={onLoadMore}>
            {intl.formatMessage(commonMessages.showMore)}
          </S.ShowMoreButton>
        </S.ShowMoreButtonWrapper>
      )}
    </>
  );
};

ProjectList.displayName = 'ProjectList';
